<template>
  <div class="modal_wrapper">
    <div class="modal notifications">
      <a href="javascript:void(0)" class="model-close-btn" @click="close">x</a>
      <div class="body">
        <div class="content mb-2" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {type: String, required: true, default: 'test'},
    durationTime: {type: Number, required: true, default: 10000}
  },
  methods: {
    close () {
      this.$emit('cancel')
    }
  },
  mounted () {
    setTimeout(() => {
      this.$emit('cancel')
    }, this.durationTime)
  }
}
</script>

<style lang="scss" scoped>
  .model-close-btn {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 25px;
    color: #2c3e50;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal-notification.vue